// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"278":"5123769a","905":"ecab1d69","988":"abe78d5a"}[chunkId] + ".chunk.css";
};